"use client";

import React, { useState } from "react";

type CollapsibleProps = {
  children: React.ReactNode;
  visibleCount: number;
};

const Collapsible = ({ children, visibleCount }: CollapsibleProps) => {
  const [expanded, setExpanded] = useState(false);
  const items = React.Children.toArray(children).flat();
  const needsCollapse = items.length > visibleCount;
  const visibleItems =
    needsCollapse && !expanded ? items.slice(0, visibleCount) : items;

  return (
    <>
      {visibleItems}
      {needsCollapse && (
        <div className="relative">
          {!expanded && (
            <div className="absolute bottom-full left-0 right-0 h-16 bg-gradient-to-t from-sand-600 to-transparent pointer-events-none" />
          )}
          <button
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            className="btn btn-secondary bg-sand-700 block mx-auto mt-4"
          >
            {expanded ? "Visa mindre" : "Visa mer"}
          </button>
        </div>
      )}
    </>
  );
};

export default Collapsible;
